@if (items() && items().length) {
  @for (item of items(); track item.labelKey()) {
    <div [class.total]="item.type() === 'total'">
      @if (item.type() === 'total') {
        <hr align="right"/>
        <hr class="last" align="right"/>
      }
      <div class="row">
        <div class="label">{{ item.labelKey() | translate }}</div>
        <div class="value">
          {{ item.value() }}
          @if (!item.hidePostfix()) {
            {{ item.postfix()}}
          }
        </div>
      </div>
    </div>
  }
}